document.querySelectorAll( '.b-post-meta' ).forEach( ( block ) => {

	const shareButtons = block.querySelector( '.js-share-article-icons' );

	if ( !shareButtons ) {

		return;

	}

	shareButtons.addEventListener( 'click', ( e ) => {

		e.preventDefault();

		const button = e.target.closest( '.social-share-icon' );

		if ( !button ) {

			return;

		}

		if ( button.classList.contains( 'share-article' ) ) {

			const title = button.getAttribute( 'data-title' );
			const url = button.getAttribute( 'data-url' );
			const medium = button.getAttribute( 'data-medium' );

			// mobile phones native sharing.
			if ( navigator.share && window.matchMedia( '(max-width: 991px)' ).matches ) {

				nativeShare( title, url );

			} else {

				// custom social sharing.
				customShare( title, url, medium );

			}

		} else if ( button.classList.contains( 'copy-url' ) ) {

			copyLink( button );

		}

	} );

	/**
	 * Opens native sharing on click.
	 *
	 * @param {string} title - The title of the article to be shared.
	 * @param {string} url - The URL of the article to be shared.
	 */
	const nativeShare = ( title, url ) => {

		if ( ! url || ! title ) {

			return

		}

		navigator.share( { title, url } );

	}

	/**
	 * Opens a sharing URL in a new window based on the attributes of the share button.
	 *
	 * @param {string} title - The title of the article to be shared.
	 * @param {string} url - The URL of the article to be shared.
	 * @param {string} medium - The social media platform to share the article on.
	 */
	const customShare = ( title, url, medium ) => {

		if ( !title || !url || !medium ) {

			return

		}

		const shareUrl = getArticleUrl( medium, url, title );
		const top = window.innerHeight / 2 - 225;
		const left = window.innerWidth / 2 - 350;

		window.open(
			shareUrl,
			'share-window',
			`height=450,width=700,top=${top},left=${left},toolbar=0,location=0,menubar=0,directories=0,scrollbars=0`
		);

	}

	/**
	 * Generates a URL for sharing an article on various social media platforms.
	 *
	 * @param {string} medium - The social media platform to share the article on. Expected values: 'facebook', 'x', 'linkedin'.
	 * @param {string} url - The URL of the article to be shared.
	 * @param {string} title - The title of the article to be shared.
	 *
	 * @return {string} The URL to be used for sharing the article on the specified platform.
	 */
	const getArticleUrl = ( medium, url, title ) => {

		switch ( medium ) {

		case 'facebook':
			return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
		case 'x':
			return `https://twitter.com/intent/tweet?url=${url}&text=${title}`;
		case 'linkedin':
			return `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;
		default:
			return url;

		}

	}

	/**
	 * Copies the link to the clipboard and displays a confirmation message.
	 *
	 * @param {Element} button - The button element that triggers the copying functionality.
	 */
	const copyLink = ( button ) => {

		const url = button.getAttribute( 'data-url' );
		const copiedInfo = button.querySelector( '.copied-link' );
		const errorInfo = button.querySelector( '.error-info' );

		if ( ! url || !copiedInfo || !errorInfo ) {

			return;

		}

		navigator.clipboard.writeText( url )
			.then( () => {

				copiedInfo.classList.add( 'copied-link--visible' );

				setTimeout( () => {

					copiedInfo.classList.remove( 'copied-link--visible' );

				}, 1500 );

			} )
			.catch( () => {

				errorInfo.classList.add( 'error-info--visible' );

				setTimeout( () => {

					errorInfo.classList.remove( 'error-info--visible' );

				}, 1500 );

			} );

	}

} );
